import React, { useEffect, useRef, useState } from "react";
import { useBoundStore } from "store/store";
import { AppBar, Box, Card, Grid, Tooltip, Typography } from "@mui/material";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import _ from "lodash";

import { ReactComponent as MachineItemsSvg } from "assets/Svgs/MachineItems.svg";
import { ReactComponent as CrossSvg } from "assets/Svgs/CrossSvg.svg";

import { MachineCardItem } from "247factorynet-packages";
import "247factorynet-packages/dist/index.css";
import DashboardTable from "./DashboardTable";
import i18n from "i18n/i18n";
import RenderKPI from "components/RenderKPI";
import { hasMalfunction } from "shared-functions/notification";
import MachineFallbackImage from "assets/Svgs/no-machine.jpg";
import { truncateWithEllipses } from "utils/helper";

function DashboardPage() {
  interface SiteData {
    [siteId: string]: {
      name: string;
      nodeid: string;
      hasarea: Array<{ area: Record<string, any> }>;
    };
  }

  const siteData: SiteData = useBoundStore((state) => state.subscribedSites);
  const getKpisData: any = useBoundStore((state) => state.getKpisData);
  

  const lang: any = useBoundStore((state) => state.lang);

  const [activeEquipment, setActiveEquipment] = useState<any>(-1);
  const [activeAreaNodeId, setActiveAreaNodeId] = useState<any>(-1);

  const [tempSiteId, SetTempSiteId] = useState<string>("");
  const [currentSiteId, setCurrentSiteId] = useState<string>("");
  const [isSitesLoading, setIsSitesLoading] = useState<boolean>(true);
  const [title, setTitle] = useState<string>(i18n(lang)?.alle_machine_parks);
  const [poolsToDisplay, setpoolsToDisplay] = useState<Array<any>>([]);
  const [equipmentName, setEquipmentName] = useState<string>("");
  const [areaName, setAreaName] = useState<string>("");

  const [startTime, setStartTime] = React.useState(0);
  const [endTime, setEndTime] = React.useState(0);

  const handleStartTimeChange = (startTime: number) => {
    setStartTime(startTime);
  };

  const handleEndTimeChange = (endTime: number) => {
    setEndTime(endTime);
  };



  const _subscribedEquipments: any = useBoundStore(
    (state) => state._subscribedEquipments 
  );   // for DashboardTable
  const userNodeId = useBoundStore((state) => state.userNodeId);
  const getEquipmentsOfArea = useBoundStore(
    (state) => state.getEquipmentsOfArea
  );
  const getEquipmentsOfSite = useBoundStore(
    (state) => state.getEquipmentsOfSite
  );

  const [allAreaEqs, setAllAreaEqs] = useState([]);
  const [showStats, setShowStats] = useState(false);
  const [filteredEquipments, setFilteredEquipments] = useState<any>([]);

  const [tabSwitched, setTabSwitched] = useState<boolean>(false);


  const areaNodeIdsByIndex: any = {};

  useEffect(() => {}, [siteData]);

  useEffect(() => {
    if (userNodeId) {
      getUser(userNodeId, true);
    }
  }, []);

  const updatePoolsToDisplay = (siteId: string) => {
    setpoolsToDisplay([]);
    let tempContainers: {
      nodeid: string;
      name: string;
      data: any[];
      key: number;
      siteName: string;
      areaName: string;
    }[] = [
      {
        nodeid: "",
        name: "alle",
        data: [],
        key: 0,
        siteName: "",
        areaName: "",
      },
    ];
    let allAreaEqs: any = [];
    let allAreaEqs2: any = [];
    if (Object.keys(siteData).length > 0) {
      let i = 0;
      for (const site of Object.keys(siteData)) {
        if (siteData[site].nodeid === siteId) {
          if (siteData[site].hasarea !== undefined) {
            for (const area of siteData[site].hasarea) {
              let tempContainer: {
                nodeid: string;
                name: string;
                data: any[];
                key: number;
                siteName: string;
                areaName: string;
              } = {
                nodeid: area.area.nodeid,
                name: area.area.name,
                data: [],
                key: i,
                siteName: siteData[site].name,
                areaName: area.area.name,
              };

              area.area?.hasequipment?.forEach(
                (equipment: { equipment?: Record<string, any> }) => {
                  const equipmentData: Record<string, any> | undefined =
                    equipment?.equipment;

                  if (equipmentData) {
                    tempContainer.data.push(equipmentData);
                    allAreaEqs.push(equipmentData.nodeid);
                    allAreaEqs2.push(equipmentData);
                  }
                }
              );

              tempContainers.push(tempContainer);

              i++;
            }
          }
        }
      }
    }
    setpoolsToDisplay(tempContainers);
    setAllAreaEqs(allAreaEqs);
    setFilteredEquipments(allAreaEqs2);
  };

  

  const [value, setValue] = React.useState(0);
  const [appBarValue, setAppBarValue] = React.useState("0");
  const setareaEqsEvents: any = useBoundStore(
    (state) => state.setareaEqsEvents
  );
  const getUser = useBoundStore((state) => state.getUser);

  const handleSiteChange = (event: React.SyntheticEvent, newValue: string) => {
    setShowStats(false);
    setTabSwitched(!tabSwitched);
    setActiveEquipment(-1);
    setValue(0);
    setAppBarValue(newValue);
    const selectedTabNodeId =
      event.currentTarget.getAttribute("aria-controls") || "";

    // Split the string based on the '==>' delimiter and get the second part
    const nodeIdParts = selectedTabNodeId.split("==>");

    // If there are at least two parts, take the second part
    const actualNodeId = nodeIdParts.length >= 2 ? nodeIdParts[1] : "";

    setCurrentSiteId(actualNodeId);

    updatePoolsToDisplay(actualNodeId);

    setActiveAreaNodeId(undefined);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveEquipment(-1);
    setActiveAreaNodeId(areaNodeIdsByIndex[newValue]);
    setValue(newValue);
    setTabSwitched(!tabSwitched);
  };

  function a11yProps(index: string) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const handleAreaChange = (index: any) => {
    if (index === -1 ) {
      setShowStats(false);
    } else {
      setShowStats(true);
    }
    setTabSwitched(!tabSwitched);
    setActiveEquipment(index);
  };

  let allAreaNotifications: any = [];

  siteData[currentSiteId]?.hasarea &&
    siteData[currentSiteId]?.hasarea.map((area: any, areaIndex: any) => {
      area.area?.hasequipment &&
        area.area?.hasequipment.map((eq: any) => {
          eq.equipment.hasnotification &&
            eq.equipment.hasnotification.map((noti: any) => {
              allAreaNotifications.push(noti);
            });
        });
    });

  if (allAreaNotifications.length) {
    // Use of _.sortBy() method
    allAreaNotifications = _.orderBy(
      allAreaNotifications,
      ["notification.type"],
      ["asc"]
    );
  }

  //hooks
  useEffect(() => {
    // render site name and menu when data is available
    const tempSiteId = Object.keys(siteData)[0];
    SetTempSiteId(tempSiteId);
    setCurrentSiteId(Object.keys(siteData)[0]);
    setIsSitesLoading(false);

    if (Object.keys(siteData).length) {
      setTitle(siteData[tempSiteId]?.name);
      setIsSitesLoading(false);
    }
  }, [siteData]);

  useEffect(() => {
    // Call getMachineData during component mount
   
  }, [siteData]);

  useEffect(() => {
    // Update poolsToDisplay when currentSiteId changes
    if (currentSiteId != "") {
      updatePoolsToDisplay(currentSiteId);
    }
  }, [currentSiteId]);

  useEffect(() => {
    if (activeEquipment !== -1) {
      setFilteredEquipments([_subscribedEquipments[activeEquipment]]);
    } else {
      if (activeAreaNodeId === -1 || activeAreaNodeId === undefined) {
        //get all equipments of site
        const equipments = getEquipmentsOfSite(currentSiteId);
        setFilteredEquipments(equipments);
      } else {
        //get all equipments of area
        const equipments = getEquipmentsOfArea(activeAreaNodeId);
        setFilteredEquipments(equipments);
      }
    }
  }, [activeAreaNodeId, currentSiteId, activeEquipment]);

 
  useEffect(() => {
    let i = 0;

    const tempArray: any = [];
    for (const item of poolsToDisplay) {
      let j = 0;

      for (const equipment1 of item.data) {
        const filteredObject = getKpisData.filter(
          (eq: { equipment: any }) => eq.equipment.nodeid === equipment1.nodeid
        );

        if (filteredObject.length > 0) {
          for (const equipmentItem of filteredObject) {
            const productName =
              equipmentItem.equipment.haslivedata[0].equipmentlivedata
                .currentproductname[0]?._value;
            const productNumber =
              equipmentItem.equipment.haslivedata[0].equipmentlivedata
                .currentproductnumber[0]?._value;

            item.data[j] = {
              ...item.data[j],
              productName,
              productNumber,
            };
            j++;
          }

        } else {
         
        }
      }
      tempArray.push(item);

      i++;
    }

    setpoolsToDisplay(tempArray);
  }, [getKpisData]);

  return (
    <div>
      <Box sx={{ bgcolor: "background.paper" }}>
        <AppBar
          className="appBar"
          position="static"
          sx={{ borderRadius: "4px" }}
          variant="elevation"
        >
          <Tabs
            value={+appBarValue}
            onChange={(event, newValue) => handleSiteChange(event, newValue)}
            indicatorColor="secondary"
            textColor="inherit"
            variant="scrollable"
            scrollButtons="auto"
            aria-label=""
          >
            {siteData &&
              Object.keys(siteData).map((key, index) => (
                <Tab
                  key={index}
                  label={siteData[key].name}
                  {...a11yProps("s==>" + siteData[key]?.nodeid)}
                  className="tab"
                />
              ))}
          </Tabs>
        </AppBar>
      </Box>

      <Card sx={{ marginTop: "2.5%" }}>
        <div className="dashboard" style={{ marginTop: "2.5%" }}>
          <div className="header">
            <div className="title">{i18n(lang)?.tab_dashboard}</div>
            
          </div>

          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label=" "
              className="customTabs"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab
                key={0}
                label={
                  <div className="customLabel">
                    <div
                      className="border"
                      style={{
                        borderTopColor: hasMalfunction(allAreaNotifications),
                      }}
                    ></div>
                    <div className="text">
                      {i18n(lang)?.all} {i18n(lang)?.areas}
                    </div>
                  </div>
                }
                {...a11yProps("s==>" + currentSiteId)}
                className="tab"
              />

              {siteData[currentSiteId]?.hasarea &&
                siteData[currentSiteId]?.hasarea.map((area, areaIndex) => {
                  areaNodeIdsByIndex[areaIndex + 1] = area.area.nodeid;

                  let areaNotifications: any = []; // getting all notifications to change border color
                  area.area?.hasequipment &&
                    area.area?.hasequipment.map((eq: any) => {
                      eq.equipment.hasnotification &&
                        eq.equipment.hasnotification.map((noti: any) => {
                          areaNotifications.push(noti);
                        });
                    });

                  if (areaNotifications.length) {
                    // Use of _.sortBy() method
                    areaNotifications = _.orderBy(
                      areaNotifications,
                      ["notification.type"],
                      ["asc"]
                    );
                  }

                  return (
                    <Tab
                      key={areaIndex}
                      label={
                        <div className="customLabel">
                          <div
                            className="border"
                            style={{
                              borderTopColor: hasMalfunction(areaNotifications),
                            }}
                          ></div>
                          <div className="text">{area.area.name} </div>
                        </div>
                      }
                      {...a11yProps("a==>" + area.area.nodeid)}
                      className="tab"
                    />
                  );
                })}
            </Tabs>
          </Box>
          {poolsToDisplay.map((item, pool) => {
            let filteredEqs = poolsToDisplay
              .filter((pool, poolIndex) => {
                return pool.key === value - 1;
              })
              .filter((arr) => {
                return arr.name !== "alle";
              });

            return (
              <>
                <CustomTabPanel value={value} index={pool}>
                  <Grid container spacing={2} sx={{ mt: 0 }}>
                    {(value === 0 ? poolsToDisplay : filteredEqs).map(
                      (item, poolIndex) =>
                        item.data.map((eq: any, equipmentIndex: number) => (
                          <Grid item xs={12} md={6} key={eq.nodeid}>
                            <div
                              onClick={(e) => {
                                handleAreaChange(eq.nodeid);
                              }}
                              style={{
                                filter:
                                  activeEquipment !== eq.nodeid &&
                                  activeEquipment !== -1
                                    ? "opacity(0.4)"
                                    : "none",
                              }}
                              key={eq.nodeid}
                              className="mesuMachineCardItemOuter"
                            >
                              <MachineCardItem
                                borderColor={hasMalfunction(
                                  _.orderBy(
                                    eq.hasnotification,
                                    ["notification.type"],
                                    ["asc"]
                                  )
                                )}
                                title={
                                  <div className="mesuMachineCardItemInner">
                                    <Tooltip title={eq.name}>
                                      <div>
                                        {truncateWithEllipses(eq.name, 50)}
                                      </div>
                                    </Tooltip>
                                    <div
                                      style={{
                                        display:
                                          activeEquipment === eq.nodeid
                                            ? "block"
                                            : "none",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleAreaChange(-1);
                                      }}
                                    >
                                      <CrossSvg className="dashCrossIcon" />
                                    </div>
                                  </div>
                                }
                                
                             

                                imageSrc={
                        eq.image && eq.image.url
                                    ? eq.image.url
                                    : MachineFallbackImage
                                }
                                icon={""}
                                iconText={
                                  <div
                                    className="flex"
                                    style={{ alignItems: "center" }}
                                  >
                                    <div style={{ marginRight: "10px" }}>
                                      {item.areaName}
                                    </div>
                                    

                                    <div className="prodNo">
                                      &nbsp; &nbsp;&nbsp;&nbsp;Produkt:
                                      {eq.productNumber === undefined
                                        ? ""
                                        : "(" + eq.productNumber + ")  "}
                                      <Tooltip title={eq.productName}>
                                        <span>
                                          {truncateWithEllipses(
                                            eq.productName,
                                            10
                                          )}
                                        </span>
                                      </Tooltip>
                                      
                                      {""}
                                      <span style={{ marginLeft: 35 }}>
                                        {i18n(lang).eq_short_id}:
                                        <Tooltip title={eq.equipmentid}>
                                          <span>
                                            {truncateWithEllipses(
                                              eq.equipmentid,
                                              5
                                            )}
                                          </span>
                                        </Tooltip>
                                      </span>
                                    </div>
                                  </div>
                                }
                                className=""
                              />
                            </div>
                          </Grid>
                        ))
                    )}
                  </Grid>

                 
                </CustomTabPanel>
              </>
            );
          })}
          <Grid item xs={12} md={6} style={{ margin: "0px 25px" }}>
            <RenderKPI
              appBarValue={appBarValue}
              siteData={siteData}
              showStatsExt={showStats}
              activeEquipment={activeEquipment}
              value={value}
              areaNodeIdsByIndex={areaNodeIdsByIndex}
            />

            <DashboardTable
              filteredEquipments={filteredEquipments}
              onStartChange={handleStartTimeChange}
              onEndChange={handleEndTimeChange}
              propStartTime={startTime}
              propEndTime={endTime}
              allAreaEqs={allAreaEqs}
              tabSwitched={tabSwitched}
            />
          </Grid>
        </div>
      </Card>
    </div>
  );
}

export default DashboardPage;
